import {prop} from 'ramda';

import {DASHBOARD_TILE_CATALOGUE} from '../consts/dashboardTileCatalogue';
import {DashboardTileId} from '../types/DashboardTileId';

export function isDashboardTileResizable(tileId: DashboardTileId): boolean {
  return prop(tileId, DASHBOARD_TILE_CATALOGUE).sizes.length > 1;
}
